export const userAvatarUrl = '';

export const webPageHost = '';

export const copilotTitle = 'Copilot';
